export const ownerscabinImageOptions = {
  angle: 'ownerscabin',
  staticOptions: {
    Veneer: 1,
    Floorboards: 1,
    FabricSaloon: 1,
    Worktop: 1,
    FabricCabins: 1,
    OwnerBerth: 1,
    AftCabinLayout: 1,
    Handrails: 1,
    PleatedBlinds: 1,
    Mast: 1
  },
  mattes: [
    {
      option: 'Veneer',
      dependency: 'OwnersCabinLayout'
    },
    {
      option: 'Floorboards',
      dependency: null
    },
    {
      option: 'FabricCabins',
      dependency: 'OwnersCabinLayout'
    },
    {
      option: 'OwnerBerth',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/XP44/views/ownerscabin.js